/**
 * Utility functions to handle different functionality
 * Expects fileURL to be passed as param
 * Returns response
 * type: success/ error
 * response: success - raw file contents
 * response: error - error message
 */

import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
// import axios from 'axios';
import { Buffer } from 'buffer';
import jwtDecode from 'jwt-decode';
import { browseAPIhandler } from './browseAPIhandler';
import { v4 as uuidv4 } from 'uuid';
import { useStore } from '../core/useStore';
import getApiBusinessDocPath from '../helpers/utilityCustomHooks/getApiBusinessDocPath';
import { useNavigate } from 'react-router-dom';
import { SVBErrorPage } from '@svb/portal-ui-react-components';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

//func to get file content
// const getFileContent = (fileURL, tokenFunc, triggerFetch) => {
//   const [response, setResponse] = useState([]);
//   // const [anontoken, setAnonToken] = useState('');
//   // const [tryCount, setTryCount] = useState(1);
//   const imgTypes = ['jpeg', 'jpg', 'png', 'raw', 'svg'];
//   const isImg = imgTypes.some((imgType) => fileURL.includes(imgType));
//   const headers = {};
//   // const retries = 3;
//   // const annonTokenGeneration = regenTokenifExpired();

//   if (isImg) {
//     headers.responseType = 'arraybuffer';
//   }

//   useEffect(() => {
//     if (typeof triggerFetch !== 'undefined' && !triggerFetch) {
//       return;
//     } // don't initiate call if triggerfetch is false and not required

//     const anontoken = regenTokenifExpired();
//     anontoken
//       .then(async (token) => {
//         headers.Authorization = token;
//         headers.uuid = uuidv4();
//         headers.audience = 'public';
//         axios
//           .get(fileURL, { headers, withCredentials: false })
//           .then((res) => {
//             console.log(res, 'ressss');
//             setResponse({
//               type: 'success',
//               response: isImg ? Buffer.from(res.data, 'binary').toString('base64') : res.data,
//             });
//             // console.log(res, 'res');
//           })
//           .catch((err) => {
//             if (err?.response) {
//               setResponse({
//                 type: 'error',
//                 response: err?.response?.statusText,
//                 errorStatusCode: err?.response?.status,
//               });
//             } else {
//               setResponse({
//                 type: 'error',
//                 response: 'Network error occured. Please check your connection.',
//                 errorStatusCode: err?.response?.status,
//               });
//             }
//           });
//       })
//       .catch((err) => {
//         console.log(err);
//         tokenFunc();
//         setResponse({
//           type: 'error',
//           response: err?.response?.statusText,
//           errorStatusCode: err?.response?.status,
//         });
//         return;
//       });
//   }, [fileURL, setResponse, triggerFetch]);
//   console.log(response, 'response');
//   return response;
// };

const getFileContent = (fileURL, tokenFunc, triggerFetch) => {
  const [response, setResponse] = useState([]);
  const imgTypes = ['jpeg', 'jpg', 'png', 'raw', 'svg'];
  const isImg = imgTypes.some((imgType) => fileURL.includes(imgType));
  const headers = {};

  if (isImg) {
    headers.responseType = 'arraybuffer';
  }

  useEffect(() => {
    if (typeof triggerFetch !== 'undefined' && !triggerFetch) {
      return;
    } // don't initiate call if triggerfetch is false and not required

    const anontoken = regenTokenifExpired();
    anontoken
      .then(async (token) => {
        headers.Authorization = token;
        headers.uuid = uuidv4();
        headers.audience = 'public';
        fetch(fileURL, {
          headers,
          credentials: 'omit',
        })
          .then(async (res) => {
            if (!res.ok) {
              throw {
                response: {
                  statusText: res.statusText,
                  status: res.status,
                },
              };
            }
            if (isImg) {
              const readImg = await res.arrayBuffer();
              const base64Data = Buffer.from(readImg).toString('base64');
              setResponse({
                type: 'success',
                response: base64Data,
              });
            } else {
              const text = await res.text();
              let parsedJson = null;
              try {
                parsedJson = JSON.parse(text);
              } catch (error) {
                //not a json, treat as plain text
              }
              if (parsedJson) {
                setResponse({
                  type: 'success',
                  response: parsedJson,
                });
              } else {
                setResponse({
                  type: 'success',
                  response: text,
                });
              }
            }
          })
          .catch((err) => {
            if (err?.response) {
              setResponse({
                type: 'error',
                response: err?.response?.statusText,
                errorStatusCode: err?.response?.status,
              });
            } else {
              setResponse({
                type: 'error',
                response: 'Network error occured. Please check your connection.',
                errorStatusCode: err?.response?.status,
              });
            }
          });
      })
      .catch((err) => {
        console.log(err);
        tokenFunc();
        setResponse({
          type: 'error',
          response: err?.response?.statusText,
          errorStatusCode: err?.response?.status,
        });
        return;
      });
  }, [fileURL, setResponse, triggerFetch]);

  return response;
};

// func to getCardIconsFile

const getCardIcons = () => {
  const contentURL = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  const setCardIconsMappingdata = (data) => useStore.setState({ cardIconsMapping: data });
  const anontoken = regenTokenifExpired();
  const getcardIconJsonData = anontoken.then(async (token) => {
    return await fetch(
      `${contentURL}/portal-content?resourcePath=pages/portal-constants-files&resourceName=cards-icon-mapping.json`,
      {
        headers: {
          Authorization: token,
          uuid: uuidv4(),
          audience: 'public',
        },
        credentials: 'omit',
      },
    )
      .then((x) => x.json())
      .then((data) => {
        setCardIconsMappingdata(data);
      })
      .catch((e) => {
        console.log(e);
      });
  });

  return getcardIconJsonData;
};
//func to build dynamic object required for cards
const buildCardJsonForAPis = (filteredApisJson, cardIconsJson) => {
  const cardIconMappingArr = cardIconsJson || useStore((state) => state.cardIconsMapping);
  let apiCardJsonData = [];
  let apiCardJsonMappedData = [];
  filteredApisJson &&
    filteredApisJson.map((resultItem) => {
      apiCardJsonData.push({
        api_display_name: resultItem?.api_display_name,
        api_description: resultItem?.api_summary,
        api_name: resultItem?.name,
        cardIcon: cardIconMappingArr[resultItem?.name],
        link: `${
          resultItem?.link
            ? resultItem?.link
            : getApiBusinessDocPath(
                resultItem?.name,
                resultItem?.version,
                resultItem?.solution_type,
              )
        }`,
      });
    });
  apiCardJsonMappedData = {
    response: apiCardJsonData,
  };
  return apiCardJsonMappedData;
};
//func to fetch custom api ordering json
const fetchCustomApisOrder = (token) => {
  const contentServer = process.env.REACT_APP_CONTENT_SERVER || '/api-content';
  return fetch(
    `${contentServer}/portal-content?resourcePath=pages/portal-constants-files&resourceName=custom-apis-weights.json`,
    {
      headers: {
        Authorization: token,
        uuid: uuidv4(),
        audience: 'public',
      },
      credentials: 'omit',
    },
  )
    .then((x) => x.json())
    .then((data) => {
      return data;
    })
    .catch((e) => {
      console.log(e);
      return;
    });
};
//func to sort apis obj based on constants file from content svc
const getCustomSortedApis = (items, weightJson) => {
  const wtdApiIdMap = weightJson.reduce((accObj, currentObj) => {
    accObj[`${currentObj.name}`] = currentObj.weight;
    return accObj;
  }, {});
  const sortedArrayItems = items.sort((x, y) => {
    const apiWeightX = wtdApiIdMap[x.name] === undefined ? Infinity : wtdApiIdMap[x.name];
    const apiWeightY = wtdApiIdMap[y.name] === undefined ? Infinity : wtdApiIdMap[y.name];

    if (apiWeightX === Infinity && apiWeightY === Infinity) {
      //if weight not found for both the compared apis, consider both of equal orders
      return 0;
    } else if (apiWeightX === Infinity) {
      //if weight for x is undefined while weight for y is defined, then defined weight is higher in order(Y>X)
      return 1;
    } else if (apiWeightY === Infinity) {
      //if weight for y is undefined while weight for x is defined, then defined weight is higher in order (X>Y)
      return -1;
    } else {
      //if weights are defined for both compared apis then sort accoring to numerical values
      return apiWeightX - apiWeightY;
    }
  });
  return sortedArrayItems;
};

const SVBErrorPageRenderer = (props) => {
  const {
    errorStatusCode,
    navigateToLink = '/',
    title = 'Something went wrong',
    btnText = 'Go Home',
  } = props;
  const navigate = useNavigate();
  const onclickHandle = () => navigate(navigateToLink);
  return (
    <SVBErrorPage
      title={title}
      errorMessage={{ statusCode: errorStatusCode }}
      buttonText={btnText}
      handleButtonClick={() => onclickHandle()}
      {...props}
    />
  );
};

//func to sort apis obj based on api weight property from browse
const sortWithAPIWeight = (items) => {
  const sortedArrayItems = items.sort((x, y) => {
    const xWeight = x.api_weight !== undefined ? x.api_weight : null;
    const yWeight = y.api_weight !== undefined ? y.api_weight : null;
    if (xWeight === null) return 1; //x item to be placed below y in case of value null
    if (yWeight === null) return -1; //y item to be placed above x in case of value null
    return x.api_weight - y.api_weight; // sorts in ascending order if both value is non null;
  });
  // filterSubVersionItems(items);
  return sortedArrayItems;
};

//func to return filtered major version objects for catalog items
const filterSubVersionItems = (items) => {
  //get major version by splitting the version string and returning first part
  const getMajorVersion = (v) => v.split('.')[0];
  // splits version string into array of number; for eg 1.2.0 to [1, 2, 0]
  const parseVersions = (version) => version.split('.').map(Number);

  const compareVersions = (v1, v2) => {
    // compares only if more than one same major version encountered;
    // for eg 1.0, 1.2 where major versions is 1 repeated 2 times
    const parsedv1 = parseVersions(v1);
    const parsedv2 = parseVersions(v2);

    //add 0(s) into parsed version arrays to make equal length later for correct comparision
    //for eg 1.0 and 1.2.1 while comparing lesser length value 1.0 will be converted to 1.0.0
    while (parsedv1.length < parsedv2.length) parsedv1.push(0); //adds 0 until length is met for v1 if v1 is lesser in length
    while (parsedv2.length < parsedv1.length) parsedv2.push(0); //adds 0 until length is met for v2 if v2 is lesser in length
    //compares value of each array for both parsed versions and returns 1 if v1 is greater and -1 if v2 is greater
    for (let i = 0; i < parsedv1.length; i++) {
      if (parsedv1[i] > parsedv2[i]) return 1;
      if (parsedv1[i] < parsedv2[i]) return -1;
    }
    return 0; //if equal returns 0
  };
  let filteredMajorVersions = {};
  items.forEach((item) => {
    const majorVersionVal = getMajorVersion(item?.version);
    const majorVersionKey = `${item?.name}-${majorVersionVal}`; //create a unique key with api machine name and majorversionvalue

    if (
      //if key with this combination doesn't exists, store current item as filteredMajorVersion
      // or if key combination(majorVersionKey) already exists compare current version with version from previous majorVersionKey item
      // and store current item as filteredMajorVersion if compare function returns 1
      !filteredMajorVersions[majorVersionKey] ||
      compareVersions(item?.version, filteredMajorVersions[majorVersionKey]?.version) > 0
    ) {
      filteredMajorVersions[majorVersionKey] = item;
    }
  });
  return Object.values(filteredMajorVersions);
};
//func to validate expiry and regenerate token if expired
const regenTokenifExpired = async () => {
  const { regenTokenandBrowse } = browseAPIhandler();
  const currentToken = localStorage.getItem('token');
  if (currentToken) {
    try {
      let decodedToken = jwtDecode(currentToken);
      let expiry = decodedToken?.exp;
      let currentTime = Math.floor(Date.now() / 1000);
      if (currentTime > expiry) {
        //token expired - refresh Token
        return await regenTokenandBrowse();
      } else {
        //use existing token
        return currentToken;
      }
    } catch (error) {
      console.log(error);
      return await regenTokenandBrowse();
    }
  } else {
    //regeneratetoken if localstorage token is null/empty
    return await regenTokenandBrowse();
  }
};
//gives us previous path for our Single Page
const usePreviousPath = () => {
  const location = useLocation();
  const previousPath = useRef(location.pathname);
  useEffect(() => {
    const currentPath = location.pathname;
    if (previousPath.current !== currentPath) {
      previousPath.current = currentPath;
    }
  }, [location]);
  return previousPath.current;
};

const useConditionalRecaptcha = () => {
  const enableRecaptcha =
    process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE === false ||
    (typeof process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE === 'string' &&
      process.env.REACT_APP_GOOGLE_RECAPTCHA_ENABLE.toLowerCase() === 'false')
      ? false
      : true;

  if (!enableRecaptcha) {
    return {
      isEnabledConditionalRecaptcha: false,
      executeConditionalRecaptcha: async () => null,
    };
  }

  const { executeRecaptcha } = useGoogleReCaptcha();

  const safeExecute = async (action) => {
    if (!executeRecaptcha) {
      console.warn('recaptcha not initialized');
      return null;
    }
    return await executeRecaptcha(action);
  };

  return {
    isEnabledConditionalRecaptcha: !!executeRecaptcha,
    executeConditionalRecaptcha: safeExecute,
  };
};

export {
  getFileContent,
  regenTokenifExpired,
  getCardIcons,
  buildCardJsonForAPis,
  fetchCustomApisOrder,
  getCustomSortedApis,
  sortWithAPIWeight,
  filterSubVersionItems,
  SVBErrorPageRenderer,
  usePreviousPath,
  useConditionalRecaptcha,
};
